module.exports = __webpack_public_path__ + "img/109.aa05437e.jpg";